import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../api.service';
import { Entity } from '../select-list/select-list.component';
import { MyUtility } from '../../comparison';

@Component({
  selector: 'app-drugs',
  templateUrl: './drugs.component.html',
  styleUrls: ['./drugs.component.css']
})
export class DrugsComponent implements OnInit {
  public title : string;
  constructor(public api : ApiService) 
  {
  }

  ngOnInit() {
  }

  get items(){
    return this.api.session.currentCriteria.drugs.selectedCategory.children;
  }

  get selectedItems() {
    return this.api.session.currentCriteria.drugs.selectedItems;
  }
  set selectedItems(value){
    MyUtility.scrubChildren(value);
    console.log("setting selected drugs to " + JSON.stringify(value));
    this.api.session.currentCriteria.drugs.selectedItems = value;
  }

  clearCurrent(){
    this.selectedItems = [];
    this.api.session.currentCriteria.drugs.groupName = null;
  }
}
